<template>
  <div class="col-sm-12 holder">
    <div class="control">
      <div class="row se">
        <div class="col-sm-12 col-md-4 col-md-push-8">
          <input type="search" class="search" id="search" placeholder="Search through subjects"  v-model="query">
        </div>
      </div>
      <div class="row se">
        <div class="form-inline">
          <select v-model="status" class="col-5 select">
            <option value="all" selected>All</option>
            <option value="PENDING">Pending</option>
            <option value="STARTED">Started</option>
            <option value="PASSED">Passed</option>
            <option value="FAILED">Failed</option>
          </select>
          <div class="input-group input-daterange col-7">
            <div class="col-sm-6">
              <datepicker v-model="from" placeholder="From" id="exampleInputEmail3" input-class="date-picker" :clear-button="true"></datepicker>
            </div>
            <div class="col-sm-6">
              <datepicker v-model="to" placeholder="To" id="exampleInputEmail4" input-class="date" :clear-button="true"></datepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="doneLoading">
      <h2>Test History</h2>
      <table class="table is-striped is-hoverable is-fullwidth">
        <thead>
          <tr>
            <td>S/N</td>
            <td>Subject</td>
            <td>Score</td>
            <td>CutOff</td>
            <td>Status</td>
            <td>Next Action</td>
            <td>Date written</td>
            <td>Next Retake</td>
            <td>Last Profile Edit</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(test, index) in filtered">
            <td>{{ index + 1 }}</td>
            <td>
              {{ test.subject && test.subject.name}}
              <br>
              <span class="sub">({{ test.ability.class_group && test.ability.class_group.name }})</span>
            </td>
            <td><span :class="testbuttontype(test)">{{ test.test ? `${calculateScore(test)}%` : '-' }}</span></td>
            <td><span>{{ calculateCutoff(test) }}%</span></td>
            <td><span :class="testbuttontype(test)">{{ teststatustext(test) }}</span></td>
            <td><button class="btn" :class="testbuttontype(test)" @click="testbuttonaction(test)">{{ testbuttontext(test) }}</button></td>
            <td>{{ test.test && test.test.taken_at && test.test.taken_at.carbon && test.test.taken_at.carbon.date ? mnt(test.test.taken_at.carbon.date).format('Do MMM, YYYY') : 'Nil' }}</td>
            <td>
              {{
                test.test
                  && test.test.taken_at
                  && test.test.taken_at.carbon
                  && test.test.taken_at.carbon.date
                    ? test.test.status === 'PASSED' ? mnt(test.test.taken_at.carbon.date).add(9, 'M').format('Do MMM, YYYY') : mnt(test.test.taken_at.carbon.date).add(3, 'M').format('Do MMM, YYYY')
                    : 'Nil'
              }}
            </td>
            <td>{{ subjectProfile(test.id) ? mnt(subjectProfile(test.id).proposed_at.carbon.date).format('Do MMM, YYYY') : 'N/A' }}</td>
          </tr>
        </tbody>
      </table>
      <router-link class="sm" :to="{ name: 'subject-classes' }" v-if="tests.length == 0">You have not selected any subject you can teach. Please click here to select the subjects you can teach.</router-link>
      <b-modal ref="editSubjectProfile" hide-footer size="lg" centered class="mkmodal" :title="`Edit subject profile for ${edited_profile.subject}`">
        <div class="d-block text-center">
          <div class="form-group">
            <p style="font-size: 1em; font-weight: 600; text-align: left; margin: 0;">Enter title</p>
            <div class="alert alert-success p-2">
              <blockquote style="background-color: rgba(255,255,255,0.5); margin: 0;" class="p-2 font-italic">
                <p style="text-align: left; font-size: .8em; margin-bottom: .5rem; font-style: italic;">Enter the title you want clients to see when they think of you as a {{ edited_profile.subject }} e.g {{ edited_profile.subject }} with 10 years Experience and 25 Straight A's ex-students</p>
              </blockquote>
            </div>
            <input type="text" placeholder="Profile Title" id="titleish" v-model="edited_profile.title" class="form-control">
          </div>
          <div class="form-group">
            <p style="font-size: 1em; font-weight: 600; text-align: left; margin: 0;">Enter full Description</p>
            <div class="alert alert-success p-2">
              <blockquote style="background-color: rgba(255,255,255,0.5); margin: 0;" class="p-2 font-italic">
                <p style="text-align: left; font-size: .8em; margin-bottom: .5rem; font-style: italic;"><b>(i). </b>Please explain your activity as a tutor/teacher in the past. <br><b>(ii). </b>Include your past achievement, interest and duration of teaching this particular subject.<br><b>(iii). </b>Please note that clients/learners would see this in your tutor profile. <br><b>(iv). </b>Try to be as descriptive as possible with relevant details. <br><b>(v). </b>Please do not repeat the same entry if you are submitting for multiple subjects otherwise it won't be approved. <br><b>(vi). </b>Minimum of <b>{{ minWordCount }}</b> words. <br><b>(vii). </b>Please don't write about your education, you already wrote about that in your bio <br><b>(viii). </b>Write more about the subject of interest. Your interest in teaching that subject/exams, your achievements about them in the past. <br><b>(ix). </b>Please don't write your name, you already wrote about that in your bio <br><b>(x). </b>Please don't use shorthand, e.g( “u are hiring the best “), type in full and proper text. <br><b>(xi). </b>Please use proper vocabulary, punctuations and appropriate use of capital letters. <br><b>(xii). </b>If the subject you are writing about is an exam, ensure you write <b>STRICTLY</b> about your experience teaching that exams with success, your interest in teaching that exam or secret tips you know to ace the particular exam. </p>
              </blockquote>
            </div>
            <editor v-model="edited_profile.content" :config="editorConfig"></editor>
            <span :class="{
              wordcount : true,
              danger: (wordsLeft < (minWordCount - 15)),
              warning: (wordsLeft < (minWordCount + 15) && wordsLeft > (minWordCount - 15))
              }">({{ wordsLeft }})</span>
          </div>
          <button class="btn btn-success btn-lg submit-button" @click.prevent="submitProfileEdit" :disabled="edited_profile.submitting">Submit and Preview <i class="fa fa-spin fa-circle-o-notch" v-show="edited_profile.submitting"></i></button>
        </div>
      </b-modal>
    </div>

    <div v-else class="row justify-content-center">
      <div class="col text-center">
        <spinner />
      </div>
    </div>
    <button class="btn btn-success submit-button" @click="nextStage">Move to next stage</button>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import swal from "sweetalert";
import Editor from "vue-ckeditor2";
import Datepicker from "vuejs-datepicker";
import Spinner from "@/components/Preloaders/Spinner";

export default {
  components: {
    Datepicker,
    Spinner,
    Editor,
  },
  props: ["isdash"],
  data() {
    return {
      doneLoading: false,
      query: "",
      status: "all",
      from: null,
      to: null,
      minWordCount: 150,
      edited_profile: {},
      editorConfig: {
        toolbar: [
          { name: "clipboard", items: ["Undo", "Redo"] },
          { name: "styles", items: ["Styles", "Format"] },
          {
            name: "basicstyles",
            items: ["Bold", "Italic", "Strike", "-", "RemoveFormat"],
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
            ],
          },
          { name: "tools", items: ["Maximize"] },
        ],
      },
    };
  },
  mounted() {
    this.doneLoading = false;
    this.$store.dispatch("getAllTests").then(() => {
      this.doneLoading = true;
      if (this.$route.query.test) {
        const dtest = this.tests.find(
          (t) => t && t.test && t.test.id === parseInt(this.$route.query.test, 10)
        );
        switch (dtest && dtest.test && dtest.test.status) {
          case "PASSED":
            return swal({
              title: "Passed!",
              text: "You passed your test. What do you want to do next? \n Congratulations, you passed your test!! The next step is to create a subject profile selling yourself as the best subject. Tell the client why they should pick you as a subject tutor out of all the others. This step is compulsary.",
              icon: "success",
              buttons: ["Another Test", "Edit Subject Profile ➜"],
            }).then((value) => {
              if (value) {
                this.editProfile(parseInt(this.$route.query.test, 10));
              }
            });

          case "FAILED":
            const threemonthsAgo = moment().subtract(3, "M");
            let testsTakenLast3Months = dtest.tests.filter((s) => {
              return (
                s.status == "FAILED" &&
                s.taken_at.carbon &&
                moment(s.taken_at.carbon.date).isAfter(threemonthsAgo)
              );
            });
            return swal({
              title: "Failed!",
              text: `You failed your test. The cutoff was ${this.calculateCutoff(
                dtest
              )}%. ${
                testsTakenLast3Months.length < 3
                  ? `You have ${3 - testsTakenLast3Months.length} trial(s) left. `
                  : ""
              }${testsTakenLast3Months.length < 3 ? 'Once you exhaust 3 trials, y' : 'Y'}ou have to wait 3 months to retake it`,
              icon: "error",
              buttons: ["Done", "Take another test 🤞🏽"],
            }).then((value) => {
              if (value) {
                this.$router.push({ name: "test-status" });
              }
            });

          default:
            return swal("Done");
        }
      }
      return null;
    });
    this.$http
      .get(`${BASE_API}/v1/tutor/ability-subjects/profiles`)
      .then((response) => {
        console.log('ability subjects profile');
        console.log(response.data);
        this.$store.commit("SET_SUBJECT_PROFILES", response.data.data);
        this.doneLoading = true;
      })
      .catch((error) => console.error(error));
  },
  computed: {
    tests() {
      console.log('here');
      console.log(this.$store.getters.tests);
      return this.$store.getters.tests;
    },
    wordsLeft() {
      if (this.textCount) {
        return this.textCount;
      }
      return 0;
    },
    textCount() {
      return this.restext && this.restext.split(/\s+|\n+/).length - 1;
    },
    restext() {
      return (
        this.edited_profile &&
        this.edited_profile.content &&
        this.edited_profile.content
          .replace(/<p>&nbsp;<\/p>/gi, "")
          .replace(/&nbsp;/gi, " ")
      );
    },
    filtered() {

      return this.tests.filter((test) => {
        console.log(this.tests);
        // filter for the search params
        if (
          test.subject &&
          !test.subject.name.toLowerCase().match(this.query.toLowerCase())
        ) {
          return false;
        }

        // date filter
        const dt =
          test.test &&
          test.test.taken_at &&
          test.test.taken_at.carbon &&
          moment(test.test.taken_at.carbon.date);
        // datefrom
        if (this.from !== null && !moment(dt).isAfter(moment(this.from))) {
          return false;
        }
        // dateto
        if (this.to !== null && !moment(dt).isBefore(moment(this.to))) {
          return false;
        }

        // filter for the status
        if (this.status === "all") {
          return true;
        }

        // if there's no test and we're looking for pending
        if (this.status === "PENDING" && !test.test) {
          return true;
        }

        return test.test && this.status === test.test.status;
      });
    },
    subjectProfiles() {
      return this.$store.getters.subjectProfiles;
    },
    subjectProfile() {
      return (id) => this.$store.getters.subjectProfile(id);
    },
  },
  methods: {
    teststatustext(test) {
      switch (test.test && test.test.status) {
        case "PENDING":
          return "Not Written Test";

        case "STARTED":
          if (
            moment().isAfter(
              moment(test.test.taken_at).add(test.test.duration, "seconds")
            )
          ) {
            return "Failed";
          }
          return "Test Started";

        case "PASSED":
          return "Passed";

        case "FAILED":
          return "Failed";

        default:
          return "Not Written Test";
      }
    },
    testbuttontext(test) {
      if (
        test.test &&
        test.test.status === "PASSED" &&
        !this.subjectProfile(test.id)
      ) {
        return "Create Profile";
      }
      switch (test.test && test.test.status) {
        case "PENDING":
          return "Write Test";

        case "STARTED":
          if (
            moment().isAfter(
              moment(test.test.taken_at).add(test.test.duration, "seconds")
            )
          ) {
            return "Retake Test";
          }
          return "Go to Test";

        case "PASSED":
          return "Edit Profile";

        case "FAILED":
          return "Retake Test";

        default:
          return "Write Test";
      }
    },
    testbuttontype(test) {
      switch (test.test && test.test.status) {
        case "PENDING":
          return "default";

        case "STARTED":
          if (
            moment().isAfter(
              moment(test.test.taken_at).add(test.test.duration, "seconds")
            )
          ) {
            return "fail";
          }
          return "info";

        case "PASSED":
          return "pass";

        case "FAILED":
          return "fail";

        default:
          return "default";
      }
    },
    testbuttonaction(test) {
      console.log('test button action');
      console.log(test);
      if (!this.isdash) {
        switch (test.test && test.test.status) {
          case "PENDING":
            return this.$router.push({
              name: "test-take",
              params: { abilitySubject: test.id },
            });

          case "STARTED":
            return this.$router.push({
              name: "test-take",
              params: { abilitySubject: test.id },
            });

          case "PASSED":
            return this.editProfile(test.test.id);

          case "FAILED":
            return this.retakeTest(test);

          default:
            return this.$router.push({
              name: "test-take",
              params: { abilitySubject: test.id },
            });
        }
      } else {
        switch (test.test && test.test.status) {
          case "PENDING":
            this.$emit("redirect", "router");
            return this.$router.push({
              name: "test-take-dash",
              params: { abilitySubject: test.id },
            });

          case "STARTED":
            this.$emit("redirect", "router");
            return this.$router.push({
              name: "test-take-dash",
              params: { abilitySubject: test.id },
            });

          case "PASSED":
            return this.editProfile(test.test.id);

          case "FAILED":
            return this.retakeTest(test);

          default:
            this.$emit("redirect", "router");
            return this.$router.push({
              name: "test-take-dash",
              params: { abilitySubject: test.id },
            });
        }
      }
    },
    calculateScore(test) {
      console.log(`scores: ${test.test.score} ; no of questions: ${test.test.no_of_questions}`);
      return test.test.score && test.test.no_of_questions
        ? Math.round(
            (parseInt(test.test.score, 10) /
              parseInt(test.test.no_of_questions, 10)) *
              100
          )
        : 0;
    },
    calculateCutoff(test) {
      return Math.round(
        test.hasOwnProperty("cutoff") ? parseFloat(test.cutoff) * 100 : 0
      );
    },
    retakeTest(test) {
      const datetaken = moment(test.test.taken_at.carbon.date);
      const retakedate = datetaken.add(3, "months");
      const threemonthsAgo = moment().subtract(3, "months");
      let testsTakenLast3Months = test.tests.filter((s) => {
        return (
          s.status == "FAILED" &&
          (s.taken_at.carbon &&
            moment(s.taken_at.carbon.date).isAfter(threemonthsAgo))
        );
      });


      if (
        test.test.status == "FAILED" &&
        (testsTakenLast3Months.length < 3 ||
        moment().isAfter(retakedate)
        )
      ) {
        this.$emit("redirect", "router");
        this.$router.push({
          name: "test-take",
          params: { abilitySubject: test.id },
        });
      } else {
        swal(
          "You can't retake this test",
          `You have to wait for ${moment
            .duration(retakedate.diff(moment()))
            .humanize()}. You are eligible to write this test on ${retakedate.format(
            "MMM D, YYYY H:mm a"
          )}`,
          "error"
        );
      }
    },
    mnt(date) {
      return moment(date);
    },
    showModal() {
      this.$refs["editSubjectProfile"].show();
    },
    hideModal() {
      this.$refs["editSubjectProfile"].hide();
    },
    editProfile(id) {
      const dtest = this.tests.find(
        (t) => t.test && t.test.id === parseInt(id, 10)
      );
      this.edited_profile = {};
      this.$set(this.edited_profile, "content", "");
      this.$set(this.edited_profile, "title", "");
      this.$set(this.edited_profile, "subject", dtest.subject.name);
      this.$set(this.edited_profile, "subject_slug", dtest.subject.slug);
      this.$set(this.edited_profile, "ability_subject_id", dtest.id);
      axios
        .get(`${BASE_API}/v1/tutor/ability-subjects/${dtest.id}`)
        .then(({ data: { data } }) => {

          if (data) {
            const { abilityProposals: proposal } = data;
            this.$set(this.edited_profile, "title", proposal.title);
            this.$set(this.edited_profile, "content", proposal.content);
          }
        });
      this.$nextTick(() => this.showModal());
    },
    submitProfileEdit() {
      if (
        this.edited_profile.title === "" ||
        this.edited_profile.title == null ||
        this.edited_profile.content === "" ||
        this.edited_profile.content == null
      ) {
        swal({
          type: "error",
          title: "Oops...",
          text: "Please fill in all fields",
          footer: "",
        });
      } else if (
        this.restext &&
        this.restext.split(/\s+|\n+/).length - 1 <= this.minWordCount
      ) {
        swal({
          type: "error",
          title: "Oops...",
          text: `You need a minimum of ${this.minWordCount} words in your full description`,
          footer: "",
        });
      } else {
        const url = `${BASE_API}/v1/tutor/subject-profile`;
        const data = {
          ability_subject_id: this.edited_profile.ability_subject_id,
          title: this.edited_profile.title,
          content: this.edited_profile.content,
          tutor_id: this.$auth.user().id,
        };
        this.$set(this.edited_profile, "submitting", true);
        this.$http
          .post(url, data)
          .then((response) => {
            if (response.data.status === false) {
              swal({
                type: "error",
                title: "Oops...",
                text: `${response.data.message} You can make an edit to a profile instead`,
                footer: "",
              }).then((value) => {
                if (value) {
                  this.$router.push({ name: "subject-profiles" });
                }
              });
            } else {
              swal({
                title: "Thank You!",
                text: `Thank you for entering your experience and interest in teaching ${this.edited_profile.subject}. \n\n Our internal Prepclass staff would review this entry before it would be published in your tutor profile. \n\n This process would take 2-24 hours depending. In the meantime, feel free to preview what your tutor profile would look like`,
                icon: "success",
                buttons: ["Cancel", "Preview ⌗"],
              }).then((value) => {
                if (value) {
                  this.$router.push({
                    name: "preview-profile",
                    params: { tutor: this.$auth.user().id },
                    query: {
                      subject: this.edited_profile.subject_slug,
                      redirect: window.location.href,
                    },
                  });
                }
              });
            }
            this.$set(this.edited_profile, "submitting", false);
          })
          .catch((error) => {

            this.$set(this.edited_profile, "submitting", false);
          });
      }
    },
    canMoveToNextStage() {
      this.$http
        .get(`${BASE_API}/v1/tutor/ability-subjects/profiles`)
        .then((response) => {
          console.log(response);
          this.$store.commit("SET_SUBJECT_PROFILES", response.data.data);
        })
        .catch((error) => console.error(error));

      const fi = this.tests.filter((t) => t.test && t.test.status === "PASSED");

      console.log('subject profiles');
      console.log(this.subjectProfiles);

      // if tutor does not have a passed subject profile
      if (this.subjectProfiles.length === 0) {
        return false;
      }

      if (this.subjectProfiles.length < fi.length) {
        return false;
      }

      return true;
    },
    nextStage() {
      console.log('can move to next stage');
      console.log(this.canMoveToNextStage());
      if (!this.canMoveToNextStage()) {
        return swal("You cannot proceed to the next page until you pass your test and create profiles for all your passed subjects");
      }
      return axios
        .post(`${BASE_API}/v1/tutor/steps`, { step: "academic_info" })
        .then(() => this.$store.dispatch("getUserTutor"))
        .then(() => {
          this.$router.push({ name: "how-it-works-setup" });
        })
        .catch((err) => console.error(err));
    },
  },
  // beforeRouteLeave(to, from, next) {
  //   if (this.canMoveToNextStage()) {
  //     return next();
  //   }
  //   if (this.subjectProfiles.length === 0) {
  //     return next();
  //   }
  //   return swal({
  //     title: 'Incomplete Profiles',
  //     text: 'Before you can be approved as Tutor on Prepclass, you have to create a subject profile for each subject passed. You are advised to create your subject profile now so that it can be approved.',
  //     buttons: ['Do it Later 😪', 'Do it now 💪🏾'],
  //   }).then((value) => {
  //     if (value) {
  //       return next(false);
  //     }
  //     return next();
  //   });
  // },
};
</script>

<style scoped lang="scss">
.swal-text {
  text-align: left;
}
.holder {
  padding: 20px 40px;
  .control {
    .se {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      margin: 20px;
    }
    .search {
      height: 50px;
      width: 100%;
      border-radius: 25px;
      background-color: #edf3e9;
      border: none;
      outline: none;
      padding: 10px 25px;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      color: #535561;
      &::placeholder {
        color: #a3a6b4;
      }
    }
    .select {
      height: 35px;
      width: 100%;
      border-radius: 18px;
      outline: none;
      cursor: pointer;
      border: none;
      box-shadow: 0 2px 2px 0 rgba(200, 200, 200, 0.14),
        0 3px 1px -2px rgba(200, 200, 200, 0.12),
        0 1px 5px 0 rgba(200, 200, 200, 0.2);
      color: #535561;
      transition: all 0.3s ease;
      font-size: 13px;
      &:active,
      &:hover {
        box-shadow: 0 8px 17px 2px rgba(200, 200, 200, 0.14),
          0 3px 14px 2px rgba(200, 200, 200, 0.12),
          0 5px 5px -3px rgba(200, 200, 200, 0.2);
      }
    }
  }
  .card {
    padding: 15px;
    margin-top: 10px;
    border-radius: 2px;
    box-shadow: 0 2px 2px 0 rgba(150, 150, 150, 0.14),
      0 3px 1px -2px rgba(150, 150, 150, 0.12),
      0 1px 5px 0 rgba(150, 150, 150, 0.2);

    h2 {
      font-size: 1.6rem;
      margin: 10px 0;
    }
    table.table {
      margin: 20px 0;
      thead {
        background-color: #edf3e9;
        tr td {
          border: none;
          text-transform: uppercase;
          color: #a3a6b4;
          font-weight: bold;
          font-size: 12px;
          text-align: center;
          padding: 15px 0;
        }
      }
      tbody {
        tr td {
          border: none;
          border-bottom: 1px solid rgba(200, 200, 200, 0.4);
          color: #535561;
          font-size: 13px;
          text-align: center;
          padding: 30px 0;
          vertical-align: middle;
          span.sub {
            font-size: 11px;
            color: #a3a6b4;
          }
          span.pass {
            color: #3e6f40;
          }
          span.fail {
            color: #ff798b;
          }
          span.default {
            color: #878787;
          }
          span:not(.sub) {
            font-weight: bold;
          }
          button {
            height: 30px;
            width: 100%;
            max-width: 130px;
            border-radius: 15px;
            line-height: 30px;
            padding: 0;
            font-size: 12px;
            font-weight: bold;
            &.pass {
              background-color: #e0f9ec;
              color: #707c76;
            }
            &.fail {
              background-color: #ffe2e6;
              color: #8a7b7d;
            }
            &.default {
              background-color: #cfdec4;
              color: #6c7466;
            }
          }
        }
      }
    }
    a.sm {
      margin-right: auto;
      margin-left: auto;
      color: #91b478;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.btn.submit-button {
  width: 150px;
  height: 38px;
  float: right;
  margin-top: 15px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14),
    0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {
      box-shadow: none !important;
    }
  }
}
#exampleInputEmail3,
#exampleInputEmail4 {
  width: 100%;
  height: 35px;
  line-height: 35px;
  border-radius: 18px;
  border: none;
  cursor: pointer;
  outline: none;
  font-size: 11px;
  box-shadow: 0 2px 2px 0 rgba(200, 200, 200, 0.14),
    0 3px 1px -2px rgba(200, 200, 200, 0.12),
    0 1px 5px 0 rgba(200, 200, 200, 0.2);
  text-align: center;
  transition: all 0.3s ease;
  &:active,
  &:hover {
    box-shadow: 0 8px 17px 2px rgba(200, 200, 200, 0.14),
      0 3px 14px 2px rgba(200, 200, 200, 0.12),
      0 5px 5px -3px rgba(200, 200, 200, 0.2);
  }
}
.vdp-datepicker__clear-button {
  position: absolute;
  top: 0;
  right: 0;
}
.control {
  margin-bottom: 25px;
}
table thead td {
  font-weight: bold;
}
table tbody td button {
  width: 100%;
}
.hide {
  display: none !important;
}
@media only screen and (max-width: 600px) {
  .hold {
    margin-bottom: 35px;
    margin-top: 20px;
  }
  .title {
    font-size: 16px;
  }
  .lssa {
    padding: 15px 0;
    h5 {
      font-size: 16px;
    }
    .sublist {
      margin-bottom: 10px;
      overflow: hidden;
      overflow-x: auto;
      ul {
        li {
          flex-shrink: 0;
          font-size: 10px;
        }
      }
    }
  }
  .submit-button {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 54px;
    float: left;
    left: 0;
    border-radius: 0;
    text-transform: uppercase;
  }
  .holder {
    padding: 20px 0;
    .control {
      .select {
      }
    }
    .card {
      padding: 0;
      box-shadow: none;
      h2 {
        font-size: 16px;
        margin: 5px 0;
      }
      table.table {
        margin: 10px 0;
        thead tr td {
          font-size: 10px;
          padding: 5px;
        }
        tbody tr td {
          font-size: 9px;
          padding: 20px 0;
          button {
            font-size: 9px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.wordcount {
  font-size: 11px;
  font-weight: bold;
  float: right;
  color: #638440;
  &.warning {
    color: rgb(255, 173, 31);
  }
  &.danger {
    color: rgb(224, 36, 94);
  }
}
.swal-text {
  text-align: center !important;
}
</style>

<style lang="scss">
.mkmodal {
  z-index: 2300;
  .modal-backdrop {
    opacity: 1;
    background-color: #111111;
    filter: blur(9px) brightness(50) opacity(50%);
  }
  .modal-content {
    border: none;
    box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    .modal-header {
      justify-content: center;
      position: relative;
      border-bottom: none;
      .modal-title {
        text-align: center;
        font-size: 1.5em;
        font-weight: 600;
      }
      .close {
        float: right;
        right: 0;
        top: 0;
        margin: 0;
        position: absolute;
      }
    }
    .modal-body {
      width: 80%;
      margin-left: auto;
      margin-right: auto;
      .form-control {
        border-radius: 4px;
        border: 1px solid #e8e9ec;
        padding: 5px 15px;
        color: #4d4f5c;
        &::placeholder {
          color: #4d4f5c;
          opacity: 0.3;
        }
      }
      select.form-control {
        option {
          padding: 10px;
        }
      }
      .quillWrapper {
        .ql-toolbar.ql-snow {
          border: 1px solid #e8e9ec;
          border-top-right-radius: 4px;
          border-top-left-radius: 4px;
          text-align: left;
          padding: 4px 15px;
          .ql-formats {
            margin: 0;
          }
          .ql-picker-label {
            font-size: 13px;
          }
          button {
            svg {
              height: 16px;
              width: 16px;
            }
          }
        }
        .ql-container.ql-snow {
          border: 1px solid #e8e9ec;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          border-top: none;
        }
      }
      .btn {
        width: 150px;
        height: 38px;
        line-height: 38px;
        padding: 0 10px;
        text-align: center;
        border-radius: 4px;
        font-size: 14px;
        vertical-align: middle;
        box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14),
          0 3px 1px -2px rgba(40, 167, 69, 0.12),
          0 1px 5px 0 rgba(40, 167, 69, 0.2);
        &:focus {
          outline: 0 !important;
          box-shadow: none !important;
          &:active {
            box-shadow: none !important;
          }
        }
      }
      .c-pane-container {
        width: 100%;
        margin-top: 0px;
        margin-bottom: 50px;
        border: none !important;
        background-color: #ffffff !important;

        .c-header {
          padding: 15px 10px;
          padding-bottom: 35px;
          .c-arrow-layout {
            padding: 10px;
            border: 1px solid #e8e9ec;
            box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
            border-radius: 4px;
          }
          .c-title {
            font-size: 14px;
            color: #639440;
          }
        }
        .c-weekdays {
          .c-weekday {
            padding: 15px;
            font-size: 12px;
            font-weight: 600;
            background-color: rgba(221, 232, 213, 1);
          }
        }
        .c-week {
          .c-day-content {
            padding: 15px;
            font-size: 11px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Profile/AcademicInfo/TestStatus.vue